// ref https://sky.sankuai.com/max/msi-api/network/request#requestget
import { request } from '@max/meituan-uni-network';
/**
 * 处理响应数据
 * @param response 响应对象
 * @returns 处理后的数据
 */
const handleResponse = (response) => {
    const { data, statusCode, status } = response;
    if (statusCode === 200 || status === 200) {
        return data;
    }
    else {
        // 如果状态码不是200，可以根据需要抛出错误或返回完整响应
        throw new Error(`请求失败，状态码：${statusCode}`);
    }
};
/**
 *
 * @param {string} url
 * @param {object} params
 */
const post = (url, params = {}) => {
    return request({
        url,
        data: params,
        method: 'POST',
        header: {
            'Content-Type': 'application/json'
        },
        _meituan: {
            requestType: 'MRNUtils' //使用MRNUtils请求（msi在请求时没有携带公参，不支持预请求）
        }
    }).then(handleResponse);
};
/**
 *
 * @param {string} url
 * @param {object} params
 */
const get = (url, params = {}) => {
    return request({
        url,
        data: params,
        method: 'GET',
        header: {
            'Content-Type': 'application/json'
        },
        _meituan: {
            requestType: 'MRNUtils' //使用MRNUtils请求（msi在请求时没有携带公参，不支持预请求）
        }
    }).then(handleResponse);
};
export { post, get };
